import { render, staticRenderFns } from "./CaseMsgView.vue?vue&type=template&id=ae3ed284&scoped=true&"
import script from "./CaseMsgView.vue?vue&type=script&lang=js&"
export * from "./CaseMsgView.vue?vue&type=script&lang=js&"
import style0 from "./CaseMsgView.vue?vue&type=style&index=0&id=ae3ed284&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae3ed284",
  null
  
)

export default component.exports